const routes = [
    {
        path: "/conservatory/application/exam-types",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "conservatoryapplicationexamtype_index",
        }
    }
];

export default routes;
